import { render, staticRenderFns } from "./LoadingBaseClassEdit.vue?vue&type=template&id=ff39df92&lang=pug"
import script from "./LoadingBaseClassEdit.vue?vue&type=script&lang=js"
export * from "./LoadingBaseClassEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports